import { useMutation } from "react-query";
import { upsertFamilyHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertFamilyHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertFamilyHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the family history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    upsertFamilyHistoryMutation: mutate,
    isUpsertFamilyHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpsertFamilyHistory;
